module.exports = __webpack_public_path__ + "img/shellfish.6ec71f2b.svg";